<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="900px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div
          *transloco="let t; read: 'reanalyze'"
          class="xi-modal__container re-analysis__container"
        >
          <h2 class="xi-modal__title">{{ t('title', { name: analysis.displayName }) }}</h2>

          <div class="xi-modal__content re-analysis__content">
            <p class="paragraph-regular text-center description">
              {{ t('content') }}
            </p>

            <form #reAnalyzeForm="ngForm">
              <p>
                {{ t('select-configuration') }}
              </p>

              <div class="flex-col spaced">
                <app-analysis-config-selector
                  [preloadedGroupConfigs]="data.groupConfigurations"
                  [collection]="data.collection.data"
                  (selectedConfig)="selectedConfiguration = $event"
                  (selectedRouteLang)="selectedRouteLanguage = $event"
                ></app-analysis-config-selector>
              </div>
            </form>
          </div>

          <div class="xi-modal__actions re-analysis__actions">
            <xi-default-button
              [text]="t('confirm')"
              [disabled]="!canSaveAnalysis(reAnalyzeForm)"
              (onClick)="closeAndAnalyse()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
